import * as React from 'react';
import './seriesPanel.scss';
import { Metadata } from '../../../types';
import { dndMove } from '../../../utils';
import { DraggableCard } from '../../DraggableCard/draggableCard';

type SeriesPanelContentProps = {
  selCards: Metadata[];
  setSelCards: React.Dispatch<React.SetStateAction<Metadata[]>>;
  currentItemRefId?: string;
  onRemove: (card: Metadata) => void;
};

export const SeriesPanelContent = ({
  selCards,
  setSelCards,
  currentItemRefId,
  onRemove
}: Readonly<SeriesPanelContentProps>) => {
  const moveSeriesItem = React.useMemo(
    () => dndMove(selCards, setSelCards),
    [selCards, setSelCards]
  );
  return (
    <div className="series-panel-content">
      <div className="select-link">
        Selected Series Items ({selCards.length})
      </div>
      <div className="series-cards-list">
        {selCards.map((card, index) => (
          <DraggableCard
            key={card.props.refId}
            card={card}
            index={index}
            onMove={moveSeriesItem}
            isCurrent={card.props.refId === currentItemRefId}
            onRemove={onRemove}
          />
        ))}
      </div>
    </div>
  );
};
